import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'Locale';
import { ConfirmationModal } from 'LocalGluons';

const SubscriptionUpgradeDialog = ({
    packageName,
    close,
    isFreemium,
    mCoreConfig,
    handleDeepLink
}) => {
    const isPackageM = packageName.includes(' M');
    const normalText = isPackageM ? 'VOD.PACKAGE1_DESCRIPTION_TXT' : 'VOD.PACKAGE2_DESCRIPTION_TXT';
    const freeText = isPackageM
        ? 'VOD.PACKAGE1_DESCRIPTION_TXT___PACKAGE.BENEFIT'
        : 'VOD.PACKAGE2_DESCRIPTION_TXT___PACKAGE.BENEFIT';

    const textKey = isFreemium ? freeText : normalText;
    const logo = isFreemium ? 'magio_kino_logo' : 'magio_cinema_logo';
    const title = isFreemium ? packageName : `${t('VOD.UPGRADE_TO_TITLE')} ${packageName}`;

    return (
        <ConfirmationModal
            logo={logo}
            header={title}
            message={`${t(textKey)} \n ${!isFreemium ? t('VOD.ORDER_INFO_TXT') : ''}`}
            onCancel={close}
            onClose={close}
            confirmLabel={
                typeof mCoreConfig.orderingServiceUrl === 'string' &&
                mCoreConfig.orderingServiceUrl.trim() !== '' &&
                mCoreConfig.orderingServiceUrl !== 'null'
                    ? t('BUY_PAID_PACKAGE.BTN___PACKAGE.BENEFIT')
                    : null
            }
            onConfirm={() => handleDeepLink()}
        />
    );
};

SubscriptionUpgradeDialog.propTypes = {
    packageName: PropTypes.string.isRequired,
    close: PropTypes.func.isRequired,
    isFreemium: PropTypes.bool.isRequired
};

export default SubscriptionUpgradeDialog;
